import { Record } from 'immutable';
import { MergeMatchInfo } from './merge-match-info';
import { OnyxEvent } from '../models/event';
import { Party } from './party';

const MergeEventRequestRecord = Record({
  action: null,
  user_id: null,
  party_initiator_type: null,
  party_initiator_code: null,
  merge_info: null,
  event: null,
  ev_tmp_guid: null,
  parties_for_unmatching: null
});

export class MergeEventRequest extends MergeEventRequestRecord {
  action: string;
  user_id: string;
  party_initiator_type: string;
  party_initiator_code: string;
  merge_info: MergeMatchInfo[];
  event: OnyxEvent;
  ev_tmp_guid: string;
  parties_for_unmatching: Party[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/merge-event-request.ts